import { render, staticRenderFns } from "./Improvements.vue?vue&type=template&id=936db296&scoped=true"
import script from "./Improvements.vue?vue&type=script&lang=js"
export * from "./Improvements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936db296",
  null
  
)

export default component.exports